import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {Observable} from 'rxjs/Observable';
import {AuthService} from '../auth.service';
import {AppConstants} from '../shared/app.constants';

@Injectable()
export class FreelancerService {

  constructor(private http: HttpClient, private auth: AuthService, private appConstants: AppConstants) {
  }

  getAssignedFreelancers(storeId): Observable<any> {
    const url = environment.apiBase + `stores/${storeId}/popup_freelancers?assigned=false`;
    const headers = this.auth.getAuthorizationHeaders();
    return this.http.get(url, {headers}).map(res => res).catch(this.appConstants.errorHandler);
  }

  getAllFreelancers(): Observable<any> {
    const url = environment.apiBase + `freelancers`;
    const headers = this.auth.getAuthorizationHeaders();
    return this.http.get(url, {headers}).map(res => res).catch(this.appConstants.errorHandler);
  }

  getFreelancers(id): Observable<any> {
    const url = environment.apiBase + `freelancers/${id}`;
    const headers = this.auth.getAuthorizationHeaders();
    return this.http.get(url, {headers}).map(res => res).catch(this.appConstants.errorHandler);
  }

  getApprovedFreelancers(storeId): Observable<any> {
    const url = environment.apiBase + `stores/${storeId}/popup_freelancers?assigned=true`;
    const headers = this.auth.getAuthorizationHeaders();
    return this.http.get(url, {headers}).map(res => res).catch(this.appConstants.errorHandler);
  }
  
  updateApprovedFreelancers(body): Observable<any> {
    const url = environment.apiBase + `stores/${body.storeId}/popup_freelancers`;
    const headers = {headers: this.auth.getAuthorizationHeaders()};
    return this.http.put(url, body.approved, headers).map(response => response).catch(this.appConstants.errorHandler);
  }
  
}



// WEBPACK FOOTER //
// /Users/bitcot/Projects/PouredHQ/getpoured-popup-angular/src/app/freelancers/freelancer.service.ts